export function isRemember(): boolean {
  //const remember = localStorage.getItem("remember");
  //return remember === "1";
  return true;
}
